import { render, staticRenderFns } from "./SignUpView.vue?vue&type=template&id=0624cdbd&scoped=true"
import script from "./SignUpView.vue?vue&type=script&lang=js"
export * from "./SignUpView.vue?vue&type=script&lang=js"
import style0 from "./SignUpView.vue?vue&type=style&index=0&id=0624cdbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0624cdbd",
  null
  
)

export default component.exports